import { classes } from '../style'
import Typography from '@mui/material/Typography'
import { Link } from 'react-router-dom'
import Button from '@mui/material/Button'
import PropTypes from 'prop-types'

const UnitEmpty = ({ unit }) => {
  return (
        <div>
            <Typography className={classes.itemListDetail}>
                No information available
            </Typography>
            <Link to={'/viewer/' + unit.buildingID + '/unit/' + unit.id} style={{ textDecoration: 'none' }}>
                <Button variant="contained" disabled={!unit.available}>View 3D Model</Button>
            </Link>
        </div>
  )
}
UnitEmpty.propTypes = {
  unit: PropTypes.object
}
export default UnitEmpty
